import React from 'react';
export const ContentBuilderCtx = React.createContext(null);
export function useContentBuilderContext() {
    return React.useContext(ContentBuilderCtx);
}
